// Main.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SearchResults from "./SearchResults";
import { SearchProvider } from "./SearchContext";
import { LoadScript } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from "./GoogleMapKey";

// Define libraries outside the component so it doesn't re-create the array
const LIBRARIES = ["places"];

const Main = () => {
  return (
    <BrowserRouter>
      <SearchProvider>
        <Routes>
          <Route path="/ca-search" element={<SearchResults />} />
          <Route path="*" element={<div>Path not matched: {window.location.pathname}</div>} />
        </Routes>
      </SearchProvider>
    </BrowserRouter>
  );
};

export default Main;
